import { cloneDeep, each, reject } from 'lodash';
import { PROJECTS_TAG } from '../../../projects/data/actions';

import {
  SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI,
  SET_ANALYSIS_STIMULI_SORTING,
  SET_ANALYSIS_STIMULI
} from './consts';

export const SET_ANALYSIS_ACTIVE_STIMULI = 'SET_ANALYSIS_ACTIVE_STIMULI';

export const setProjectAnalysisStimuli = stimuli => {
  return {
    type: SET_ANALYSIS_STIMULI,
    stimuli
  };
};

export const setProjectAnalysisStimuliSorting = stimuliSorting => {
  return {
    type: SET_ANALYSIS_STIMULI_SORTING,
    stimuliSorting
  };
};

export const setStimuliSortingIds = stimuli => {
  return (dispatch, getState) => {
    const { stimuliSorting } = getState().analysis.single;
    const { layers } = getState().analysis.single;
    const rejected = reject(layers, l => {
      return l.id in stimuliSorting;
    }).map(layer => {
      return layer.id;
    });

    each(rejected, layer => {
      stimuliSorting[layer] = stimuli.map(s => {
        return s.id;
      });
    });

    dispatch(setProjectAnalysisStimuliSorting(stimuliSorting));
  };
};

export const fetchProjectAnalysisStimuli = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(PROJECTS_TAG, 'getProjectStimuli', {
      projectId,
      $limit: 100
    });
    dispatch(setProjectAnalysisStimuli(results.data));
    dispatch(setStimuliSortingIds(results.data));
  };
};

/**
 * Set selected stimuli
 * @param selectedStimuliId
 * @returns {{type: string, stimuli: *}}
 */
export const setCarouselSelectedStimuliId = selectedStimuliId => {
  return {
    type: SET_ANALYSIS_SELECTED_CAROUSEL_STIMULI,
    selectedStimuliId
  };
};

export const setActiveStimuliId = activeStimuliId => {
  return {
    type: SET_ANALYSIS_ACTIVE_STIMULI,
    activeStimuliId
  };
};

export const stimuliSortingUpHandler = () => {
  return (dispatch, getState) => {
    const { activeLayerId } = getState().analysis.single;
    const { activeStimuliId } = getState().analysis.single;

    if (activeLayerId === null || activeStimuliId === null) {
      return;
    }

    const layerStimuliSorting = cloneDeep(getState().analysis.single.stimuliSorting);
    const activeLayerStimuliSorting = layerStimuliSorting[activeLayerId].slice();
    const activeStimuliIndex = activeLayerStimuliSorting.indexOf(activeStimuliId);

    if (activeStimuliIndex === 0) {
      return;
    }

    const itemToSwap = activeLayerStimuliSorting[activeStimuliIndex];
    const toIndex = activeStimuliIndex - 1;

    activeLayerStimuliSorting[activeStimuliIndex] = activeLayerStimuliSorting[toIndex];
    activeLayerStimuliSorting[toIndex] = itemToSwap;

    dispatch(
      setProjectAnalysisStimuliSorting({
        ...layerStimuliSorting,
        [activeLayerId]: activeLayerStimuliSorting
      })
    );
  };
};

export const stimuliSortingDownHandler = () => {
  return (dispatch, getState) => {
    const { activeLayerId } = getState().analysis.single;
    const { activeStimuliId } = getState().analysis.single;

    if (activeLayerId === null || activeStimuliId === null) {
      return;
    }

    const layerStimuliSorting = cloneDeep(getState().analysis.single.stimuliSorting);
    const activeLayerStimuliSorting = layerStimuliSorting[activeLayerId].slice();
    const activeStimuliIndex = activeLayerStimuliSorting.indexOf(activeStimuliId);

    if (activeStimuliIndex === activeLayerStimuliSorting.length - 1) {
      return;
    }

    const itemToSwap = activeLayerStimuliSorting[activeStimuliIndex];
    const toIndex = activeStimuliIndex + 1;

    activeLayerStimuliSorting[activeStimuliIndex] = activeLayerStimuliSorting[toIndex];
    activeLayerStimuliSorting[toIndex] = itemToSwap;

    dispatch(
      setProjectAnalysisStimuliSorting({
        ...layerStimuliSorting,
        [activeLayerId]: activeLayerStimuliSorting
      })
    );
  };
};



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/stimuliActions.js